import { Tooltip as TooltipPrimitive } from 'radix-ui';
import { type ReactNode } from 'react';

import { TooltipArrow, TooltipContent } from './styles';

export { HighZIndexTooltipContent, TooltipArrow } from './styles';

const DEFAULT_COLLISION_PADDING = 24;

export interface IBaseTooltipProps
  extends TooltipPrimitive.TooltipProviderProps {
  children: ReactNode;
  contentProps?: Omit<TooltipPrimitive.TooltipContentProps, 'children'>;
  dataCy?: string;
  disabled?: boolean;
  message?: ReactNode | string;
}

export const BaseTooltip = ({
  children,
  contentProps,
  dataCy = 'tooltip-field',
  disabled = false,
  message,
  ...props
}: IBaseTooltipProps): JSX.Element => {
  const { collisionPadding, ...restContentProps } = contentProps ?? {};

  return (
    <TooltipPrimitive.Provider {...props}>
      <TooltipPrimitive.Root
        delayDuration={300}
        open={disabled ? false : undefined}
      >
        <TooltipPrimitive.Trigger asChild>{children}</TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipContent
            sideOffset={5}
            data-cy={dataCy}
            {...restContentProps}
            collisionPadding={collisionPadding ?? DEFAULT_COLLISION_PADDING}
          >
            {message}
            <TooltipArrow />
          </TooltipContent>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
